import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'
import '../stylesheets/index.less'

ReactDOM.unstable_createRoot(document.getElementById('root')).render(<App initProps={window.initProps}/>)
